import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/2250716421345?text=Bonjour, je souhaite des informations sur vos produits";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14 fade-up">
          <h2
            className="text-3xl md:text-4xl font-semibold text-stone-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Contactez-nous
          </h2>
          <p className="text-base md:text-lg text-stone-600 max-w-xl mx-auto">
            Notre équipe est disponible pour répondre à toutes vos questions.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
            {/* Phone */}
            <div
              data-testid="contact-phone"
              className="fade-up fade-up-delay-1 bg-white rounded-2xl p-6 flex items-start gap-4 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
            >
              <div className="w-12 h-12 rounded-2xl bg-[#6C3FC5]/10 flex items-center justify-center flex-shrink-0">
                <Phone size={22} className="text-[#6C3FC5]" />
              </div>
              <div>
                <h3 className="font-medium text-stone-900 mb-1 text-sm">Téléphone & WhatsApp</h3>
                <a
                  href="tel:+2250716421345"
                  className="text-[#6C3FC5] font-semibold hover:underline"
                >
                  +225 07 16 42 13 45
                </a>
              </div>
            </div>

            {/* Email */}
            <div
              data-testid="contact-email"
              className="fade-up fade-up-delay-2 bg-white rounded-2xl p-6 flex items-start gap-4 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
            >
              <div className="w-12 h-12 rounded-2xl bg-[#6C3FC5]/10 flex items-center justify-center flex-shrink-0">
                <Mail size={22} className="text-[#6C3FC5]" />
              </div>
              <div>
                <h3 className="font-medium text-stone-900 mb-1 text-sm">Email</h3>
                <a
                  href="mailto:santekacinoe@gmail.com"
                  className="text-[#6C3FC5] font-semibold hover:underline text-sm"
                >
                  santekacinoe@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* WhatsApp CTA */}
          <div className="fade-up fade-up-delay-3 text-center">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-button"
              className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#128C7E] text-white px-10 py-4 rounded-full text-base font-medium transition-all duration-200 hover:scale-105 shadow-lg shadow-[#25D366]/25"
            >
              <MessageCircle size={22} />
              Écrire sur WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
